"use strict";

var ToDoFilters = function () {
  let lastSmartFilter;
  let lastDataView;

  var initializeFilters = function () {
    lastDataView = Tree.get("dataView");

    lastSmartFilter?.destroy();

    if (!DataViewFunctions.getCurrentDataViewProperty("smartToDoFilters", lastDataView)) {
      return;
    }

    const filterConfigs = DataViewFunctions.getCurrentDataViewProperty(
      "filterModule",
      lastDataView,
    ).getFilterConfigs?.();
    if (filterConfigs) {
      setSmartFilters(filterConfigs);
    }

    return lastSmartFilter;
  };

  var setSmartFilters = function (filterConfigs) {
    lastSmartFilter = new SmartFilters(filterConfigs, {
      defaultFilters: Filters.getDefaultFilters(),
      treePath: "smartToDoFilters",
    });
    lastSmartFilter.init($("#todo-filters-modal"));
  };

  const getLastSmartFilter = function () {
    if (Tree.get("dataView") !== lastDataView) {
      return initializeFilters();
    }

    return lastSmartFilter;
  };

  return {
    initializeFilters,
    getLastSmartFilter,
  };
};

module.exports = ToDoFilters();

const DataViewFunctions = require("../dataViewFunctions");
const Tree = require("../tree");
const SmartFilters = require("./smartFilters.js");
const Filters = require("./filters.js");
